import { Text } from '@simplywallst/ui-core';
import { getStaticUrl, useCloudflareImage } from '@/hooks/useCloudflareImage';

import {
  OnboardingSlide,
  OnboardingSlideShow,
} from '@components/OnboardingSlides';
import type { OnboardingSlideShowProps } from '@components/OnboardingSlides';

type Props = Pick<
  OnboardingSlideShowProps,
  'footer' | 'dismissOnboardingSlideshow'
>;

export const PortfolioOnboardingSlideShow = (props: Props) => {
  const portfolioBenefits = useCloudflareImage({
    src: getStaticUrl('portfolio/onboarding-slides/portfolio-benefits.png'),
    height: 280,
    width: 390,
  });
  const portfolioRisks = useCloudflareImage({
    src: getStaticUrl(
      'portfolio/onboarding-slides/portfolio-risk-detection.png'
    ),
    height: 280,
    width: 390,
  });
  const portfolioAll = useCloudflareImage({
    src: getStaticUrl(
      'portfolio/onboarding-slides/portfolio-all-in-one-view.png'
    ),
    height: 280,
    width: 390,
  });
  const portfolioBrokerages = useCloudflareImage({
    src: getStaticUrl('portfolio/onboarding-slides/portfolio-brokerages.png'),
    height: 280,
    width: 390,
  });
  const portfolioWeeklyUpdates = useCloudflareImage({
    src: getStaticUrl(
      'portfolio/onboarding-slides/portfolio-weekly-summary.png'
    ),
    height: 280,
    width: 390,
  });
  const portfolioOpportunities = useCloudflareImage({
    src: getStaticUrl(
      'portfolio/onboarding-slides/portfolio-opportunities.png'
    ),
    height: 280,
    width: 390,
  });
  const portfolioMoreFeatures = useCloudflareImage({
    src: getStaticUrl('portfolio/onboarding-slides/more-features.png'),
    height: 280,
    width: 390,
  });

  return (
    <OnboardingSlideShow backgroundColor="phantom" {...props}>
      <OnboardingSlide image={portfolioBenefits}>
        <Text typography="largeStrong" textAlign="center">
          Discover new portfolio! Powerful features on the way.
        </Text>
        <Text typography="xSmall" textAlign="center">
          Create a new portfolio to get started!
        </Text>
      </OnboardingSlide>
      <OnboardingSlide image={portfolioRisks}>
        <Text typography="largeStrong" textAlign="center">
          Intelligent risk detection and alerts for your holdings
        </Text>
      </OnboardingSlide>
      <OnboardingSlide image={portfolioAll}>
        <Text typography="largeStrong" textAlign="center">
          All your portfolios in one view
        </Text>
      </OnboardingSlide>
      <OnboardingSlide image={portfolioBrokerages}>
        <Text typography="largeStrong" textAlign="center">
          Direct sync with popular brokers
        </Text>
      </OnboardingSlide>
      <OnboardingSlide image={portfolioWeeklyUpdates}>
        <Text typography="largeStrong" textAlign="center">
          Weekly Summary and key events
        </Text>
      </OnboardingSlide>
      <OnboardingSlide image={portfolioOpportunities}>
        <Text typography="largeStrong" textAlign="center">
          Timely insights without the noise
        </Text>
      </OnboardingSlide>
      <OnboardingSlide image={portfolioMoreFeatures}>
        <Text typography="largeStrong" textAlign="center">
          More insights and tools are coming to help you build a successful
          portfolio
        </Text>
      </OnboardingSlide>
    </OnboardingSlideShow>
  );
};
